import { UserModel } from "../../user/_models/user.model";

export class GroupModel {
  id: number;
  name: string;
  permissions: any[];
}
